<template>
  <v-app>
    <nav-bar :user="currentUser"></nav-bar>
    <v-main class="scroll-container">
      <router-view :user="currentUser" />
    </v-main>
    <footer-comp class="footer" v-if="showFooter()"></footer-comp>
    <!-- <div style="text-align: center; margin: 1rem 0; width: 500px; margin: 0 auto;">
      <h1>Welcome to nginx!</h1>
      <p>
        If you see this page, the nginx web server is successfully installed and
        working. Further configuration is required.
      </p>
  
      <p>
        For online documentation and support please refer to
        <a href="http://nginx.org/">nginx.org</a>.<br />
        Commercial support is available at
        <a href="http://nginx.com/">nginx.com</a>.
      </p>
  
      <p><em>Thank you for using nginx.</em></p>
    </div> -->
  </v-app>
</template>

<script>
import NavBar from "./components/layout/NavBar.vue";
import FooterComp from "./components/layout/Footer.vue"  ;

import { apiClient, handleError } from "./common/api/api.middleware";
import { useAuthStore } from "./store/auth.store";
import { apis } from "./common/api/api.constants";
import "./assets/css/style.css";
import * as Sentry from "@sentry/vue";

export default {
  components: { NavBar, FooterComp },
  name: "App",
  created() {
    this.checkIfLoggedIn();
  },
  mounted() {
    // document.getElementById("app").innerHTML = "";
  },
  data: () => ({
    //
    currentUser: null,
    currentIndex: 0,
    routes: [
      "/",
      "/about",
      "/contests?view=grid",
      "/photographers?view=grid",
      "/tutorial",
    ], // Add your routes here
  }),
  // mounted() {
  //   window.addEventListener("scroll", this.debouncedScroll);
  // },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.debouncedScroll);
  // },
  methods: {
    checkIfLoggedIn() {
      const pcnAccessToken = localStorage.getItem("pcn_access_token");
      if (pcnAccessToken) {
        this.getUserDetailsByAccessToken(pcnAccessToken);
      }
    },
    async getUserDetailsByAccessToken(token) {
      try {
        const response = await apiClient.get(
          `${apis.userDetails}?token=${token}`
        );
        const authStore = useAuthStore();
        authStore.user = response.data.data;
        this.currentUser = response.data.data;

        Sentry.setUser({
          user_id: this.currentUser.user_id,
          email: this.currentUser.email_address,
          name: this.currentUser.name,
        });
      } catch (error) {
        handleError(error);
      }
    },
    showFooter() {
      const allowedRoutes = [
        "/",
        "/login",
        "/signup",
        "/forgot-password",
        "/contests",
        "/photographers",
        "/shop",
        "/settings",
        "/privacy-policy",
        "/terms-and-conditions",
        "/tutorial",
      ];

      if (!this.currentUser) {
        return allowedRoutes.includes(this.$route.path);
      } else {
        return (
          allowedRoutes.includes(this.$route.path) &&
          this.currentUser.roles[0].role_name !== "admin"
        );
      }
    },
    // Debounce function to limit scroll event triggering
    debouncedScroll() {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(this.handleScroll, 200); // 200ms debounce
    },
    handleScroll() {
      // Get the footer's height
      const footerHeight = this.$refs.footer
        ? this.$refs.footer.offsetHeight
        : 0;
      console.log("footerHeight", footerHeight);

      // Adjust scrollable height by excluding footer height
      const scrollable =
        document.documentElement.scrollHeight - window.innerHeight - 240;
      const scrolled = window.scrollY;

      // Check if the user scrolled to the bottom of the page (ignoring footer)
      if (scrolled >= scrollable) {
        this.loadNextRoute();
      }
    },
    loadNextRoute() {
      if (this.currentIndex < this.routes.length - 1) {
        this.currentIndex += 1;
        this.$router.push(this.routes[this.currentIndex]);
      } else {
        // Loop back to the first route if at the end
        this.currentIndex = 0;
        this.$router.push(this.routes[this.currentIndex]);
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700&display=swap");
/* @import "./assets/css/style.css"; */

:root {
  --priamry-color: "#009eff";
  --secondary-color: "#ff5a00";
  --text-primary: "#151740";
}

html {
  scroll-behavior: smooth;
}

body {
  overflow-x: hidden;
  scroll-behavior: smooth;
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

>>> .v-btn {
  text-transform: capitalize;
}

.footer {
  margin-top: 5rem;
}

/* Optional, ensure scroll is detected properly */
.scroll-container {
  /* height: 100vh; */
  overflow-y: scroll;
}
</style>
